import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import WhatWeDo from "./pages/WhatWeDo";
import CSR from "./pages/CSR";
import Career from "./pages/Career";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Donation from "./pages/Donation";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Admin from "./pages/Admin";
import Gallery from "./pages/Gallery";
import Documents from "./pages/Documents";
import Accounting from "./pages/Accounting";
import AccountingLogin from "./pages/AccountingLogin";
import Members from "./pages/Members";
import VerifyMember from "./pages/VerifyMember";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/csr" element={<CSR />} />
          <Route path="/career" element={<Career />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<Donation />} />
          <Route path="/donation" element={<Donation />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/accounting/login" element={<AccountingLogin />} />
          <Route path="/accounting" element={<Accounting />} />
          <Route path="/admin/members" element={<Members />} />
          <Route path="/verify/:memberId" element={<VerifyMember />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
